/*
 * DO NOT ADD ANYTHING HERE.
 * CONFIG SHOULD BE LOADED AT RUNTIME USING ConfigService and config.json
 */
export const environment = {
  production: true,
};
